import { render, staticRenderFns } from "./provision-phone-number-plan.vue?vue&type=template&id=7315fb68&scoped=true&"
import script from "./provision-phone-number-plan.vue?vue&type=script&lang=js&"
export * from "./provision-phone-number-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7315fb68",
  null
  
)

export default component.exports